import { useLayoutEffect, useRef } from "react";
import "./ContactHeader.css";
import gsap from "gsap";

export default function ContactHeader() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });
      tl.from(".ch-eyebrow", { y: 16, opacity: 0, duration: 0.6 }, 0.1)
        .from(".ch-title .line", { yPercent: 110, duration: 0.9, stagger: 0.1, ease: "expo.out" }, 0.2)
        .from(".ch-sub", { y: 16, opacity: 0, duration: 0.6 }, 0.6);
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <div ref={rootRef} className="contact-header">
      <div className="ch-bg" aria-hidden>
        <div className="ch-orb ch-orb--1" />
        <div className="ch-orb ch-orb--2" />
        <div className="ch-grid" />
      </div>
      <div className="ch-inner">
        <span className="ch-eyebrow eyebrow">Get in touch</span>
        <h1 className="ch-title">
          <span className="line-wrap"><span className="line">Contact <span className="grad-text">me</span></span></span>
        </h1>
        <p className="ch-sub">Have an idea? Let's build it — I'm usually replying within a few hours.</p>
      </div>
    </div>
  );
}
